import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge, Tooltip, OverlayTrigger, Dropdown } from "react-bootstrap";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import OrderPayment from '../../../modal/Corporate_Management/Manage_Payment/Payment';
import VerifyPay from '../../../modal/Corporate_Management/Manage_Payment/PaymentVerification';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";  

const CorporatePaymentList = () => {
  const tableRef = useRef(null);

  const [modalType, setModalType] = useState("");
  const [open, setOpen] = useState(false);
  const BaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalEntries, setTotalEntries] = useState(0);
  const [loading, setLoading] = useState(true);

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  // const getOrderStatus = (status) => {
  //   const map = {
  //     1: { label: "Ordered", bgColor: "#fff700", textColor: "black" },
  //     2: { label: "Order Confirmed", bgColor: "#9ff551", textColor: "black" },
  //     3: { label: "Order Postponed", bgColor: "#18bff1", textColor: "black" },
  //     4: { label: "Order Cancelled", bgColor: "#ff1a1aba", textColor: "white" },
  //     5: { label: "Payment Pending", bgColor: "#7e00afff", textColor: "white" },
  //     6: { label: "Out For Delivery", bgColor: "#536ae3", textColor: "white" },
  //     7: { label: "Delivered", bgColor: "#00812d", textColor: "white" },
  //   };

  //   return map[status] || { label: "Unknown", bgColor: "#ccc", textColor: "black" };
  // };

  const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

  const fetchOrders = async () => {
    try {
      const response = await axios.get(`${BaseUrl}/manage_corporate_order/payment_list`, {
        params: { branch_id }
      });
      const data = response.data && Array.isArray(response.data.data) ? response.data.data : [];


      const filtered = data.filter(order => {
        const search = searchTerm.toLowerCase();

        function searchValues(obj) {
          for (const key in obj) {
            if (!obj.hasOwnProperty(key)) continue;
            const value = obj[key];
            if (value === null || value === undefined) continue;

            if (typeof value === "string" || typeof value === "number") {
              if (value.toString().toLowerCase().includes(search)) {
                return true;
              }
            } else if (typeof value === "object") {
              if (searchValues(value)) return true;
            }
          }
          return false;
        }

        return searchValues(order);
      });


      setTotalEntries(filtered.length);

      // Pagination logic
      const start = (page - 1) * perPage;
      const paginatedData = filtered.slice(start, start + perPage);

      setOrders(paginatedData);
      setLoading(false);

    } catch (error) {
      setOrders([]);
      toast.error("Failed to fetch orders");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, perPage, searchTerm]);

  const totalPages = Math.ceil(totalEntries / perPage);

  const closeModal = async () => {
    setOpen(false);
    setSelectedOrder(null);
    await fetchOrders();
  };

  const handleOrderPayment = (order) => {
    setSelectedOrder(order);
    setModalType("OrderPayment");
    setOpen(true);
  };

  const handleVerifyPayment = (order) => {
    setSelectedOrder(order);
    setModalType("VerifyPay");
    setOpen(true);
  };

  useEffect(() => {
    if (tableRef.current) {
      if (!$.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable({
          "responsive": true,
          pageLength: 25,
          //   "aaSorting": [],
          "ordering": false,
          "language": {
            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
          },
          "dom":
            "<'row'" +
            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
            ">" +
            "<'table-responsive'tr>" +
            "<'row'" +
            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
            ">"
        });
      }
    }
  }, []);


  return (
    <>
      {loading ? (
        <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
          <div className='mb-2'>
            <div className="mb-0 px-0">
              <h4 style={{ color: '#025d3a' }}><Skeleton width={150} /></h4>
            </div>
            <ol className="breadcrumb fs-7">
              <li className="breadcrumb-item"><Skeleton width={70} /></li>
              <li className="breadcrumb-item"><Skeleton width={20} /></li>
              <li className="breadcrumb-item active"><Skeleton width={100} /></li>
            </ol>
          </div>
        </div>
      ) : (
        <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
          <div className='mb-0'>
            <div className="mb-0 px-0">
              <h4 className='breadcrumb-header'>Manage Corporate Payment</h4>
            </div>
            <ol className="breadcrumb fs-7">
              <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
              <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
              <li className="breadcrumb-item active">Corporate Management</li>
            </ol>
          </div>
          {open && modalType === "OrderPayment" && (
            <OrderPayment
              show={open}
              onClose={closeModal}
              order={selectedOrder}
            />
          )}
          {open && modalType === "VerifyPay" && (
            <VerifyPay show={open}
              onClose={closeModal}
              order={selectedOrder}
            />
          )}
          
          <div className="d-flex flex-row align-items-end justify-content-between gap-2 bg-gray-300 border border-gray-700 py-2 px-2 rounded">
            
            <div className="d-flex flex-row align-items-center justify-content-center gap-2">
                <label className='py-3 px-3 rounded border border-gray-700' style={{ backgroundColor: '#d0fff0' }}></label>
                <span>-</span>
                <label className='text-black font-w600 fs-7'>Payment Completed</label>
            </div>
        </div>
        </div>
      )}

      {loading ? (
        <div className="table-container">
          <div className="d-flex justify-content-between align-items-center mb-3">
            {/* Left: Show entries dropdown */}
            <div>
              <label className="me-2"><Skeleton width={50} height={25} /></label>
              <Skeleton width={50} height={25} className="mb-1" />
            </div>

            {/* Right: Search input */}
            <div>
              <Skeleton width={150} height={25} className="mb-1" />
            </div>
          </div>

          <table style={{ borderBottom: '2px solid #ddd' }} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
            <thead>
              <tr>
                <th><Skeleton width={100} height={16} /></th>
                <th><Skeleton width={100} height={16} /></th>
                <th><Skeleton width={100} height={16} /></th>
                <th><Skeleton width={100} height={16} /></th>
                <th><Skeleton width={100} height={16} /></th>
                <th><Skeleton width={100} height={16} /></th>
              </tr>
            </thead>
            <tbody className="text-gray-600 fw-semibold fs-7">
              {[...Array(perPage)].map((_, i) => (
                <tr key={i}>
                  <td><Skeleton /></td>
                  <td><Skeleton /></td>
                  <td><Skeleton /></td>
                  <td><Skeleton /></td>
                  <td><Skeleton /></td>
                  <td><Skeleton /></td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="d-flex justify-content-between align-items-center mt-3">
            {/* Bottom left: Showing x to y of z entries */}
            <div>
              <Skeleton width={180} height={15} />
            </div>

            {/* Bottom right: Pagination */}
            <nav>
              <div className="d-flex gap-2">
                {[...Array(4)].map((_, i) => (
                  <Skeleton key={i} width={40} height={25} borderRadius={5} />
                ))}
              </div>
            </nav>
          </div>
        </div>
      ) : (
        <div className="table-container">

          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              <label className="me-2">Show</label>
              <select
                className="form-select d-inline w-auto"
                style={{ fontSize: "0.85rem", height: "30px" }}
                value={perPage}
                onChange={(e) => {
                  setPerPage(Number(e.target.value));
                  setPage(1);
                }}
              >
                {[10, 25, 50, 100].map((num) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <input
                type="text"
                style={{ fontSize: "0.85rem", height: "40px" }}
                placeholder="Search..."
                className="form-control"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setPage(1);
                }}
              />
            </div>
          </div>

          <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
            <thead>
              <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                <th className="min-w-80px">Scheduled / paid Date</th>
                <th className="min-w-100px">Customer / Mob No</th>
                <th className="min-w-100px text-center">Order Id / Pay Mode</th>
                <th className="min-w-100px">Total Amt</th>
                <th className="min-w-100px">Payment Amt</th>
                <th className="min-w-100px text-center">Paid Amt</th>
                <th className="min-w-100px text-center">Payment Status</th>
              </tr>
            </thead>
            <tbody className="text-gray-600 fw-semibold fs-7">
              {orders.length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center">
                    No orders found.
                  </td>
                </tr>
              ) : (
                orders.map((order) => {
                  console.log(order);
                  const paymentMode = (order.payment_mode_label || '').toUpperCase();
               

                  const firstOrder = order.corp_orders && order.corp_orders.length > 0 ? order.corp_orders[0] : null;
                  console.log('first_order', order);

                  if (firstOrder != null) {
                    return (
                      // <tr
                      //   key={order.id}
                      //   style={order.order_status === "1" ? { backgroundColor: "#ffb4aaff" } : {}}
                      // >
                      <tr
                            key={order.id}
                            style={
                              order.status === 1
                                ? { backgroundColor: "#d0fff0" }
                                : order.order_status === "1"
                                ? { backgroundColor: "#ffb4aaff" }
                                : {}
                            }
                          >
                        <td>
                          <label className="text-black font-w600 fs-7">
                            {firstOrder && order.payment_schedule_date ? formatDate(order.payment_schedule_date) : "-"}
                          </label>
                          <div className="d-block">
                            <label className="text-primary font-w600 fs-8">
                              {firstOrder && order.initialPayDate ? formatDate(order.initialPayDate) : "-"}
                            </label>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex flex-wrap flex-column">
                            <label className="text-black font-w600 fs-7 me-2">
                              {order.corp_customer?.customer_name || "-"}
                            </label>
                            <label className="text-primary font-w600 fs-8">
                              {order.corp_customer?.customer_number || "-"}
                            </label>
                          </div>
                        </td>
                        <td className="text-center">
                          <div className="d-flex flex-wrap flex-column">
                            <label className="text-black font-w600 fs-7 me-2">
                              {firstOrder?.catering_id || "-"}
                            </label>
                            <label className="text-primary font-w600 fs-8">{paymentMode}</label>
                          </div>
                        </td>
                        {/* <td>
                          <div className="d-flex flex-wrap flex-column gap-1">
                            <span>
                              <Badge bg="success" className="text-white fs-7 py-0 px-2">
                                ₹ {order ? parseFloat(order.total_amount) : 0}
                              </Badge>
                            </span>
                            {
                              firstOrder.total - firstOrder.advance_amount == order.amount && firstOrder.couponamount > 0 && (
                                <label className="text-black font-w500 fs-7">
                                  <span>
                                    <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                                  </span>
                                  <OverlayTrigger
                                    trigger="['hover','trigger']"
                                    placement="bottom"
                                    overlay={
                                      <Tooltip className="toltip-popover">
                                        <span className="fs-8 text-white fw-semibold">Discount Amount</span>
                                      </Tooltip>
                                    }
                                  >
                                    <span>{firstOrder.couponamount}</span>
                                  </OverlayTrigger>
                                </label>
                              )
                            }
                          </div>
                        </td> */}
                          <td className='text-end'>
                                                  <div className="d-flex flex-column gap-1 align-items-end">
                                                    <span>
                                                      <Badge bg="success" className="text-white fs-7 py-0 px-2">
                                                        ₹ {Number(order.total_amount).toLocaleString('en-IN')}
                                                      </Badge>
                                                    </span>
                        
                                                    {firstOrder.total - firstOrder.advance_amount === order.amount &&
                                                      firstOrder.couponamount > 0 && (
                                                        <label className="text-black font-w500 fs-7">
                                                          <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                                                          <OverlayTrigger
                                                            trigger={['hover', 'focus']}
                                                            placement="bottom"
                                                            overlay={
                                                              <Tooltip className="toltip-popover">
                                                                <span className="fs-8 text-white fw-semibold">Discount Amount</span>
                                                              </Tooltip>
                                                            }
                                                          >
                                                            <span>{Number(firstOrder.couponamount).toLocaleString('en-IN')}</span>
                                                          </OverlayTrigger>
                                                        </label>
                                                      )}
                                                  </div>
                                                </td>
                        {/* <td>
                          <div className="d-flex flex-wrap flex-column gap-1 justify-content-start align-items-center">
                            <label className="text-black font-w500 fs-7">
                              <span>
                                <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                              </span>
                              <span>{parseFloat(order.amount)}</span>
                            </label>
                            {
                              Number(order.gst_amount) !== 0 && (
                                <label className="text-danger font-w500 fs-7">
                                  <span>
                                    <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                                  </span>
                                  <OverlayTrigger
                                    trigger="['hover','trigger']"
                                    placement="bottom"
                                    overlay={
                                      <Tooltip className="toltip-popover">
                                        <span className="fs-8 text-white fw-semibold">GST Amount</span>
                                      </Tooltip>
                                    }
                                  >
                                    <span>{order.gst_amount}</span>
                                  </OverlayTrigger>
                                </label>
                              )
                            }
                          </div>
                        </td> */}
                           <td className='text-end'>
                                                  <div className="d-flex flex-column gap-1 align-items-end">
                                                    <label className="text-black font-w500 fs-7">
                                                      <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                                                      <span>{Number(order.amount).toLocaleString('en-IN')}</span>
                                                    </label>
                        
                                                    {Number(order.gst_amount) !== 0 && (
                                                      <label className="text-danger font-w500 fs-7">
                                                        <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                                                        <OverlayTrigger
                                                          trigger={['hover', 'focus']}
                                                          placement="bottom"
                                                          overlay={
                                                            <Tooltip className="toltip-popover">
                                                              <span className="fs-8 text-white fw-semibold">GST Amount</span>
                                                            </Tooltip>
                                                          }
                                                        >
                                                          <span>{Number(order.gst_amount).toLocaleString('en-IN')}</span>
                                                        </OverlayTrigger>
                                                      </label>
                                                    )}
                                                  </div>
                                                </td>
                        {/* <td className="text-center">
                          <span>
                            <Badge bg="danger" className="text-white fs-7 py-0 px-2">
                              ₹ {parseFloat(order.paidAmount)}
                            </Badge>
                          </span>
                        </td> */}

                           <td className="text-end">
                                                  <Badge bg="danger" className="text-white fs-7 py-0 px-2">
                                                    ₹ {Number(order.paidAmount).toLocaleString('en-IN')}
                                                  </Badge>
                                                </td>
                        <td className="text-end">
                          {order.status === 0 ? (
                            <OverlayTrigger
                              trigger="['hover', 'trigger']"
                              placement="bottom"
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <span className="fs-8 text-white fw-semibold">Pay</span>
                                </Tooltip>
                              }
                            >
                              <Button
                                variant="primary tp-btn-light px-2 py-1"
                                onClick={() => handleOrderPayment(order)}
                              >
                                <label className="bg-primary text-white rounded fs-7 py-1 px-2">Pay</label>
                              </Button>
                            </OverlayTrigger>
                          ) : order.status === 2 ? (
                            <Dropdown drop="">
                              <Dropdown.Toggle as="a" className={`i-false cursor-pointer`}>
                                <label
                                  className="text-black py-1 px-2 rounded font-w600 fs-7 cursor-pointer"
                                  style={{ backgroundColor: "#fff700" }}
                                >
                                  Verification Pending
                                </label>
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  href="#"
                                  className="text-black"
                                  onClick={() => handleVerifyPayment(order)}
                                >
                                  Verify
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          ) : order.status === 1 ? (
                            <div className="d-flex flex-wrap flex-row justify-content-center align-items-center gap-2">
                              <label
                                className="text-white rounded fs-7 py-1 px-2"
                                style={{ backgroundColor: "#514fc9" }}
                              >
                                Paid
                              </label>
                            </div>
                          ) : order.status === 3 ? (
                            <div className="d-flex flex-wrap flex-row justify-content-center align-items-center gap-2">
                              <label
                                className="text-white rounded fs-7 py-1 px-2"
                                style={{ backgroundColor: "#e74c3c" }}
                              >
                                Cancelled
                              </label>
                            </div>
                          ) : null}
                        </td>
                      </tr>
                    );
                  }
                })
              )}
            </tbody>
          </table>

          <div className="d-flex justify-content-between align-items-center mt-3">
            <div>
              {orders.length > 0 ? (
                <span className="text-muted">
                  Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + orders.length} of {totalEntries} entries
                </span>
              ) : (
                <span className="text-muted">Showing 0 to 0 of 0 entries</span>
              )}
            </div>

            <nav>
              <ul className="pagination mb-0" style={{ fontSize: "0.75rem" }}>
                {/* Previous Button */}
                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    style={{ padding: "0.25rem 0.5rem" }}
                    onClick={() => setPage(page - 1)}
                    disabled={page === 1}
                  >
                    Previous
                  </button>
                </li>

                {/* First Page */}
                <li className={`page-item ${page === 1 ? "active" : ""}`}>
                  <button
                    className="page-link"
                    style={{ padding: "0.25rem 0.5rem" }}
                    onClick={() => setPage(1)}
                  >
                    1
                  </button>
                </li>

                {/* Left Ellipsis */}
                {page > 4 && (
                  <li className="page-item disabled">
                    <span className="page-link" style={{ padding: "0.25rem 0.5rem" }}>
                      ...
                    </span>
                  </li>
                )}

                {/* Pages Around Current */}
                {Array.from({ length: totalPages }, (_, i) => i + 1)
                  .filter((p) => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                  .map((p) => (
                    <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
                      <button
                        className="page-link"
                        style={{ padding: "0.25rem 0.5rem" }}
                        onClick={() => setPage(p)}
                      >
                        {p}
                      </button>
                    </li>
                  ))}

                {/* Right Ellipsis */}
                {page < totalPages - 3 && (
                  <li className="page-item disabled">
                    <span className="page-link" style={{ padding: "0.25rem 0.5rem" }}>
                      ...
                    </span>
                  </li>
                )}

                {/* Last Page */}
                {totalPages > 1 && (
                  <li className={`page-item ${page === totalPages ? "active" : ""}`}>
                    <button
                      className="page-link"
                      style={{ padding: "0.25rem 0.5rem" }}
                      onClick={() => setPage(totalPages)}
                    >
                      {totalPages}
                    </button>
                  </li>
                )}

                {/* Next Button */}
                <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    style={{ padding: "0.25rem 0.5rem" }}
                    onClick={() => setPage(page + 1)}
                    disabled={page === totalPages}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>

        </div>
      )}

    </>
  )


}
export default CorporatePaymentList;